import styled from "styled-components";

const CardWrapper = styled.div`
  width: 100%;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .l-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    text-align: center;

    h3 {
      /* font-weight: 500; */
    }

    h5 {
      color: ${({ color }) => color};
      font-size: 0.95rem;
      font-weight: 400;
    }
  }

  .r-info {
    align-items: center;
    text-align: center;

    h3 {
      font-weight: 500;
      font-size: 1.2rem;
    }
  }
`;

export interface ILargeCardProps {
  value: number;
  title: string;
  status: string;
  description: string;
  color: string;
}

export function MetricsCard2({
  title,
  value,
  status,
  description,
  color,
}: ILargeCardProps) {
  return (
    <CardWrapper>
      <div className="l-info">
        <h3>{title}</h3>
        <h5>{description}</h5>
      </div>
      <div className="r-info">
        <h2 style={{ color: color }} className="approved">
          {value}
        </h2>
        <span>{status}</span>
      </div>
    </CardWrapper>
  );
}
